import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";

export const ProductCard = ({ product, onAdd, testIdPrefix = "product" }) => {
  const { t } = useLang();
  return (
    <div className="card-luxury group" data-testid={`${testIdPrefix}-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block image-zoom aspect-[4/5] overflow-hidden bg-black">
        <img src={product.cover} alt={product.title} loading="lazy" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition" />
      </Link>
      <div className="p-5">
        <div className="overline mb-2 text-[var(--monzal-text-2)] capitalize">{product.category}</div>
        <Link to={`/product/${product.id}`}>
          <h3 className="font-display text-base text-white tracking-tight leading-snug min-h-[2.5rem]">
            {product.title}
          </h3>
        </Link>
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-white/5">
          <div className="text-[var(--monzal-gold)] font-display font-semibold">
            ${product.price.toLocaleString()}
            <span className="text-gray-500 text-xs ml-1 font-mono-tech">{product.currency}</span>
          </div>
          <button
            data-testid={`${testIdPrefix}-add-${product.id}`}
            onClick={() => onAdd && onAdd(product)}
            className="text-[11px] uppercase tracking-[0.18em] font-display text-gray-300 hover:text-[var(--monzal-gold)] transition-colors"
          >
            {t("shop.addToCart")} +
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
